import React from 'react';
import { textSelectionNone } from 'shared/design-system/base/TrueImpactText';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import styled from 'styled-components';

interface BorderedButtonProps {
  minWidth?: number;
  text: string;
  onClick?: () => unknown;
  className?: string;
}

const StyledButton = styled.button`
  padding: 16px;
  width: 100%;
  min-width: ${({ minWidth }: { minWidth: number }) => minWidth}px;
  color: ${COLORS.ctaPrimary};
  border: 1px solid ${COLORS.ctaPrimary};
  border-radius: 4px;
  text-align: center;
  ${textSelectionNone}
  cursor: pointer;
  font-weight: 600;
  background-color: ${COLORS.whiteBase};
  color: ${COLORS.ctaPrimary}
  transition: background-color 150ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
  &:hover {
    background-color: ${COLORS.ctaPrimaryBackground};
  }
  &:active, &:focus {
    background-color: ${COLORS.ctaPrimary};
    color: ${COLORS.whiteBase}
  }
`;

const BorderedButton: React.FC<BorderedButtonProps> = ({
  minWidth = 194,
  text,
  onClick,
  className,
}) => {
  return (
    <StyledButton minWidth={minWidth} onClick={onClick} className={className}>
      {text}
    </StyledButton>
  );
};

export default BorderedButton;
